import { MouseEvent, useState } from 'react'
import { memo } from 'react'

import Motion from '@/organisms/Motion'

import AccordionLabel from './AccordionLabel'
import css from './scss/Accordion.module.scss'
import { AccordionProps } from './ts/AccordionTypes'

function Accordion(props: AccordionProps) {
  const { children, heading, alwaysOpen = false } = props
  const [expanded, setExpanded] = useState(true)

  const toggle = (event: MouseEvent<HTMLElement>) => {
    if (alwaysOpen) return event.preventDefault()
    setExpanded(!expanded)
  }

  return (
    <details open>
      <summary className={css.summary} role="button" onClick={toggle}>
        <AccordionLabel
          heading={heading}
          expanded={expanded}
          alwaysOpen={alwaysOpen}
        />
      </summary>
      {expanded && <Motion className="pt-6">{children}</Motion>}
    </details>
  )
}

export default memo(Accordion)
